import { PassengerType } from './PassengerType';

export class CancelSimulateModel {
	 pnrId;
	 pnrNumber;
	 date ;
	 transactionId;
	 adyenTransactionId;
	 statusAntiFraud;
	 payment;
	 simulation;
	 passengerInfo;
}

export class CancelInfoModel {
	constructor(
		 quotationDate,
		 totalPayment,
		 totalSimulate,
		 balance,
		 operation
	) {}
}

export class SimulationModel {
	 total;
	 operation;
	 invoice;
}

export class PriceResponse {
	 currency;
	 value;
}

export class Exchange {
	 exchangeRate;
}

export const InvoiceType ={
	TOTAL_PAYMENT : "TOTAL_PAYMENT",
	BALANCE : "BALANCE"
}

export const Currency= {
	BRL : "BRL",
	POINTS : "POINTS",
	USD : "USD"
}

export const StatusAntiFraud={
	PDT : "PDT",
	APA : "APA",
	SUS : "SUS",
	FRD : "FRD"
}

export const Operation = {
	REFUND : 'REFUND',
	NOT_REFUNDABLE : 'NOT_REFUNDABLE',
	PAYMENT : 'PAYMENT',
	NOT_OPERATION : 'NOT_OPERATION',
	REFUND_FREE :'REFUND_FREE',
	PAYMENT_FREE : 'PAYMENT_FREE'
	
}

export class PassengerInfo {
	 quantity;
	 totalValue;
	 isReimbursable;
}



// WEBPACK FOOTER //
// ./src/const/CancelModel.js